import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { inviteeUpdated, inviteeAuthorized, visited } from '../actions/invitee';

const mapStateToProps = state => ({});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ inviteeUpdated, inviteeAuthorized }, dispatch);
}

class Session extends Component {
  url = process.env.REACT_APP_API_URL;

  async getInviteeFromDatabase(id) {
    let invitee = null;

    try {
      const result = await fetch(`${this.url}/invitees/${id}`);

      if (result.status !== 200) throw result.status;
      const data = await result.json();
      invitee = Object.assign({}, data, { id });
    } catch (err) {
      console.log(`invitee doesn't exist`);
    }

    if (invitee !== null) {
      this.props.inviteeUpdated(invitee);
      this.props.inviteeAuthorized();

      visited(invitee.id);
    }
  }

  getInvitee({ match }) {
    const id = match.params.id;

    this.getInviteeFromDatabase(id);

    return <Redirect to="/" />;
  }

  render() {
    return (
      <Route path="/invitees/:id" component={this.getInvitee.bind(this)} />
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Session);



// WEBPACK FOOTER //
// ./src/components/Session.js